/*
  Icon with text — re-rolls the [random] number on every page load.

  Why JS is needed: Liquid has no real random filter, and a rendered page
  can sit in Shopify's CDN cache for a long time, freezing the number.
  Running in the browser gives a fresh value on every load.

  Only touches elements that carry data-random-min/max, i.e. the merchant
  enabled "re-roll on each page load". When disabled, Liquid still prints a
  number and this script leaves it alone.
*/
(function () {
  var SELECTOR = '.m-icon-with-text__random[data-random-min][data-random-max]';

  function randomize(el) {
    var min = parseInt(el.getAttribute('data-random-min'), 10);
    var max = parseInt(el.getAttribute('data-random-max'), 10);

    if (isNaN(min) || isNaN(max)) return;
    if (max < min) {
      var tmp = min;
      min = max;
      max = tmp;
    }

    var value = Math.floor(Math.random() * (max - min + 1)) + min;
    el.textContent = value.toLocaleString();
  }

  function run(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(randomize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      run();
    });
  } else {
    run();
  }

  // The theme editor re-renders sections — re-run for the new markup
  document.addEventListener('shopify:section:load', function (event) {
    run(event.target);
  });
})();
